import { css, type Theme } from "@emotion/react";

import { dimensions, helpers } from "@styles";

const disabledOpacityZero = css`
  &:disabled {
    opacity: 0;
  }
`;

const positionRelative = css`
  position: relative;
  transition: opacity 0.3s ease-out;
`;

export const arrowNavWrapper = () => css`
  ${positionRelative}

  > button {
    ${disabledOpacityZero}
  }

  &:hover,
  &:focus {
    > button {
      opacity: 1;

      ${disabledOpacityZero}
    }
  }
`;

export const shadowWrapper = (theme: Theme) => css`
  ${positionRelative}

  &:after {
    ${helpers.scrollFade("90deg", theme)};
    right: 0;
  }

  &:before {
    ${helpers.scrollFade("-90deg", theme)};
    left: 0;
  }
`;

export const showShadow = {
  left: css`
    &:before {
      opacity: 1;
    }
  `,
  right: css`
    &:after {
      opacity: 1;

      @media (max-width: ${dimensions.tabletMax}) {
        right: -1rem;
      }
    }
  `,
};

export const slider = {
  base: css`
    overflow: hidden;
  `,
  overflowItems: css`
    @media (max-width: ${dimensions.tabletMax}) {
      width: 100vw;
      padding-right: 2rem;
    }
  `,
};

export const slidesContainer = {
  base: css`
    display: flex;
    gap: 1rem;
  `,
  looping: css`
    > div:last-of-type {
      margin-right: 1rem;
    }
  `,
  fullWidthItems: css`
    > div {
      width: 100%;
    }
  `,
};
